module.exports = __webpack_public_path__ + "login-bck.f4bf9efe59fc1422369e.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/assets/images/login-bck.png
// module id = ../../../../../src/assets/images/login-bck.png
// module chunks = main